var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","multiple":_vm.length > 1},on:{"change":function($event){return _vm.uploadFile($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }